const colours = {
  base: {
    grey: {
      200: "#E1E5E3",
    },
  },
  ws: {
    orders: {
      bg: "#EFEEEE",
    },
  },
  ops: {
    lightGrey: "#E1E4E3",
    error: "#EE0000",
    black: "#293D38",
    pink: {
      50: "#FFF1F6",
      100: "#FDDFEA",
      200: "#FECBDD",
      300: "#FBACC8",
      600: "#F489AF",
      900: "#D74B9C",
    },
    yellow: {
      100: "#F8F3D2",
      200: "#FFEBB3",
      300: "#EFE7B0",
      900: "#D09800",
    },
    grape: {
      100: "#FAF4F7",
      200: "#EBE4F4",
      300: "#E5C8D6",
      600: "#503E59",
      900: "#38003D",
      counter: {
        600: "#38003D",
      },
    },
    green: {
      200: "#DDF4DC",
      300: "#C3E5C2",
      600: "#7AB182",
      900: "#08512D",
    },
    red: {
      100: "#FFECEB",
      200: "#FFE1DE",
      300: "#FCD4D0",
      900: "#532219",
    },
    grey: {
      100: "#F6F6F6",
      200: "#ECF0EE",
      300: "#D1D6D5",
      500: "#667085",
      600: "#B1B2B2",
      800: "#6E6E6E",
      900: "#363B3A",
      counter: {
        600: "#A2A3A3",
      },
    },
    purple: {
      300: "#EFE8FF",
      600: "#DCD0FB",
      900: "#7E5CDB",
    },
    blue: {
      100: "#F2F5FF",
      200: "#ECF0FF",
      300: "#ECF0FF",
      600: "#BECEFA",
      800: "#7FA1F7",
      900: "#4568C2",
    },
  },
  primary: {
    accent: "#2C3432",
  },
  brand: {
    primary: "#3D0021",
    secondary: "#293D38",
  },
  gray: {
    lightest: "#E5E5E5",
    lighter: "#D1D6D5",
    light: "#768283",
    dark: "#1E1E1E",
  },
  status: {
    received: "#C3E5C2",
    ordered: "#E6E8EB",
    cancelled: "#F3C2B2",
  },
  background: {
    main: "#F4F0F2",
    hover: "#fff8fb",
  },
  // main colours
  black: "#293D38",
  accent1: "#F4F6F5",
  accent2: "#EAEEEC",
  accent3: "#D1D6D5",
  accent4: "#A4ABAB",
  accent5: "#768283",
  accent6: "#465B58",
  accent7: "#2E3D3B",
  grey: "#C6CAD2",
  adminGrey: "#C6CAD2",
  white: "#FFFFFF",

  // Solid
  navy: "#012F4D",
  maroon: "#3D0021",
  green: "#B1E870",
  darkGreen: "#117D47",
  blue: "#05A6FF",
  aliceBlue: "#EAF0FF",
  darkBlue: "#0F137D",
  purple: "#9170E9",
  yellow: "#F7D731",
  bone: "#F6F1E8",

  // Tint
  greenTint: "#E0F6C7",
  blueTint: "#CCEDFE",
  maroonTint: "#E0D6DB",
  maroonPale: "#F4F0F2",
  greyTint: "#EAEEEC",

  // Pale
  greenPale: "#4ACA59",

  // Message colors
  error: {
    default: "#ED0200",
    dark: "#CC0000",
    bright: "#FF191A",
    pale: "#F5CBCC",
    lightPale: "#FFE0E0",
  },
  success: {
    bright: "#38CB60",
    default: "#33BA57",
    dark: "#1FA042",
    pale: "#D2ECD9",
  },
  warning: {
    bright: "#F7B955",
    default: "#F5A622",
    dark: "#f49B0B",
    pale: "#FDEBCE",
    lightPale: "#FFF3E0",
  },
  warningSecondary: {
    bright: "#FEE668",
    default: "#F7D731",
    dark: "#EAC60B",
  },
  // Quick Quote colors
  quickQuote: {
    pale: "#EFE8FF",
    default: "#9171E9",
  },

  //
  ghost: "#C7CAD2",
  graph: {
    green: "#88895E",
    pink: "#CCBAB7",
  },
  brightGray: "#EFEBED",

  // Activity colors
  activity: {
    green: "#33ba57",
    yellow: "#fcd53f",
    orange: "#f5a623",
    red: "#ee0000",
  },

  orders: {
    default: "#B190A1",
    pale: "#FFFAFD",
  },

  fullBlack: "#000000",
};

export default colours;
